import styled, { css } from 'styled-components';
import mq from '../../utils/mediaQueries.js';
import { isGlobetrotter } from '../../utils/theming.js';
import Icon from '../Icon/Icon.js';

// @ts-nocheck
var List = styled.ul.withConfig({
  displayName: "style__List",
  componentId: "sc-xowknu-0"
})(["display:flex;gap:1em 3em;flex-wrap:wrap;", " ", ""], mq.sMax(css(["padding:2em 0;"])), mq.s(css(["justify-content:center;padding:2em 2em 1em;"])));
var ListItem = styled.li.withConfig({
  displayName: "style__ListItem",
  componentId: "sc-xowknu-1"
})(["display:flex;line-height:1.4;", ""], function (props) {
  return props.$animate && css(["opacity:", ";transform:scale(", ");transition:opacity 0.75s,transform 0.75s;"], props.$intersected ? 1 : 0, props.$intersected ? 1 : 0);
});
var CheckIcon = styled(Icon).withConfig({
  displayName: "style__CheckIcon",
  componentId: "sc-xowknu-2"
})(["flex:0 0 auto;margin:0.2em 0.5em 0;color:var(--color-grass-500);", ""], isGlobetrotter(css(["color:var(--color-almostblack);"])));

export { CheckIcon, List, ListItem };
//# sourceMappingURL=style.js.map
